exports.IDS = {
  // IMG_URL: "http://127.0.0.1:7778",
  // IMG_URL: "http://192.168.16.53:7778",
  IMG_URL: "https://winluckynode.profcymadev.com:7779",

  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  BLOCK: "BLOCKED",
  UNBLOCK: "UNBLOCKED",
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },
};
